import { mlsProviderIds } from 'constants/mlsProviderIds';
import type Listing from 'data/listing';
import type { Room } from 'data/listing';

/**
 * Resolves which rooms to render on the address page.
 *
 * Within the `ListingPropertyDetailsRedesign` feature, Centris listings prefer their
 * locale-specific rooms (localized type/level) so the Rooms section matches the active
 * locale. Every other case — non-redesign, non-Centris, or a Centris listing without
 * locale rooms — falls back to the top-level {@link Listing.rooms}.
 *
 * @param listing The listing whose rooms should be resolved.
 * @param preferLocaleRooms Whether the redesign feature is active for this render.
 */
export function resolveDisplayRooms(listing: Listing, preferLocaleRooms: boolean): Room[] | null {
  if (preferLocaleRooms && listing.providerId === mlsProviderIds.centris) {
    const localeRooms = listing.localizedRooms;
    if (localeRooms && localeRooms.length > 0) {
      return localeRooms;
    }
  }
  return listing.rooms;
}
